/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const branchSlice = createSlice({
    name: 'branchSlice',
    initialState: {
        branches: [],
        range: [0, 0],
        category: '',
        ride: '',
        selectedBranch: '',
        entryTickets: [],
        rideTickets: [],
        pagination: null,
        categories: [],
    },
    reducers: {
        setBranches: (state, action) => {
            state.branches = action.payload;
            if (action.payload?.length > 0) {
                state.selectedBranch = action.payload[0].id;
                state.entryTickets = [];
                state.rideTickets = [];
            }
        },
        selectBranch: (state, action) => {
            state.selectedBranch = action.payload;
        },
        setRange: (state, action) => {
            state.range = action.payload;
        },
        setCategory: (state, action) => {
            state.category = action.payload;
        },
        setRide: (state, action) => {
            state.ride = action.payload;
        },
        setCategories: (state, action) => {
            state.categories = action.payload;
        },
        setEntryTickets: (state, action) => {
            state.entryTickets = action.payload;
        },
        setRideTickets: (state, action) => {
            state.rideTickets = action.payload;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
    },
});
export const {
    setBranches,
    selectBranch,
    setRange,
    setCategory,
    setRide,
    setEntryTickets,
    setRideTickets,
    setPagination,
    setCategories,
} = branchSlice.actions;

export default branchSlice.reducer;
